import React from "react";
import "./Service_Specification.css";

const Service_Specification = ({ spcifications, specifictaionDescn }) => {
  return (
    <div className="Service_Specification">
      <div className="container">
        <div className="specification_main_div">
          <div className="row">
            {spcifications?.map((item) => {
              return (
                <div className="col-md-6 col-6">
                  <div className="specification_div">
                    <div className="left_side">
                      <img src={item?.img} className="left_img" />
                    </div>
                    <div className="text_holder">
                      <p className="main_text">{item?.titleText}</p>
                      <p className="sub_text">{item?.subText}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <p className="spec_descn">{specifictaionDescn}</p>
        </div>
      </div>
    </div>
  );
};

export default Service_Specification;
